export const HttpJsonHeader = {
  Accept: "application/json",
  "Content-type": "application/json",
};
export const BackgroundColor = "#060b26";
